export const PencilIcon = ({ color = "#FFFFFF", size = 16, ...props }) => (
    <svg
        width={size}
        height={size * (14 / 16)}
        viewBox="0 0 16 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M0.881836 11.0837L0.881836 14L3.84753 14L12.5943 5.39897L9.62864 2.48271L0.881836 11.0837ZM14.8878 3.14373C15.1962 2.84044 15.1962 2.35051 14.8878 2.04722L13.0372 0.227468C12.7288 -0.0758228 12.2305 -0.0758228 11.9221 0.227468L10.4749 1.6506L13.4405 4.56687L14.8878 3.14373Z"
            fill={color}
        />
    </svg>
);
